// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
angular
  .module('CustomerSupport')
  .service('CustomerSupportService', function ($http) {
    const customerSupportService = {
      sendEmail(data) {
        return $http.post(
          siteMap.cleanRelativePath('/customer-support/send-email-or-case'),
          data,
          {
            transformRequest: angular.identity,
            headers: { 'Content-Type': undefined },
          }
        );
      },
      getCountries() {
        return $http.get(
          siteMap.cleanRelativePath('/customer-support/get-countries'),
          { headers: { Accept: 'application/json' } }
        );
      },
    };
    return customerSupportService;
  });
